module.exports = __webpack_public_path__ + "assets/img/36_1508.129408b3.jpg";